import { Box, styled, Typography } from "@mui/material";

export interface LoginSwitchProps {
    checked: boolean;
    label: string;
    onChange: (checked: boolean) => void;
}

const Track = styled(Box)<{ ownerState: { active: boolean } }>(({ ownerState }) => ({
    position: "relative",
    width: 44,
    height: 26,
    flexShrink: 0,
    borderRadius: 999,
    border: "none",
    cursor: "pointer",
    padding: 0,
    backgroundColor: ownerState.active ? "#528CD6" : "#B1C3D0",
    transition: "background-color 180ms ease",
}));

const Knob = styled(Box)<{ ownerState: { active: boolean } }>(({ ownerState }) => ({
    position: "absolute",
    top: 3,
    left: ownerState.active ? 21 : 3,
    width: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: "#fff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
    transition: "left 180ms ease",
}));

export const LoginSwitch = ({ checked, label, onChange }: LoginSwitchProps) => {
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Track
                ownerState={{ active: checked }}
                role="switch"
                aria-checked={checked}
                tabIndex={0}
                onClick={() => onChange(!checked)}
                onKeyDown={(event) => {
                    if (event.key !== "Enter" && event.key !== " ") return;
                    event.preventDefault();
                    onChange(!checked);
                }}
            >
                <Knob ownerState={{ active: checked }} />
            </Track>
            <Typography
                variant="body2"
                sx={{ color: "text.secondary", cursor: "pointer", userSelect: "none" }}
                onClick={() => onChange(!checked)}
            >
                {label}
            </Typography>
        </Box>
    );
};
